import React from 'react';
import './ProofHeader.css';

const ProofHeader = ({ proofT }) => {
  return (
    <div className="enterprise-header">
      <div className="header-accent"></div>
      <h1 className="enterprise-title">{proofT('header.title')}</h1>
      <p className="enterprise-subtitle">
        {proofT('header.subtitle')}
      </p>
    </div>
  );
};

export default ProofHeader;






